<template>
  <div class="show">
    <b-tabs content-class="mt-3">
      <div v-for="semana in semanas" :key="semana">
        <b-tab :title="semana" :active="semana == 'Segunda' ? true : false">
          <div class="form-group col-xl-12">
            <button class="btn btn-primary" style="margin-left: 90%" @click="addFood(semana)">
              + Refeição
            </button>
          </div>
          <div class="card col-xl-5" style="margin-right: 30px; display: inline-block" v-for="food in foods[semana]"
            :key="food">
            <div class="card-header">
              <label>Refeição {{ food.id }}</label>
              <input style="border-color: #e2815e; width: 150px; display:inline-block" maxlength="5" type="text"
                v-model="food.time" placeholder="12:00" class="form-control" />
              <button class="btn" @click="removeFood(food.id, semana)">
                <i class="fa fa-close"></i>
              </button>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-xl-12">
                  <div class="media align-items-center mb-3">
                    <div class="media-body">
                      <!-- Detecta se tem opcoes (formato IA) ou não (formato antigo) -->

                      <!-- Nome da Refeição (sempre editável) -->
                      <label class="text-muted small uppercase">Nome da Refeição</label>
                      <input type="text" class="form-control mb-2" v-model="food.nome"
                        placeholder="Ex: Café da manhã" />

                      <!-- FORMATO COM OPÇÕES (IA) -->
                      <div v-if="food.opcoes && food.opcoes.length > 0">
                        <label class="text-muted small uppercase">Opções de Refeição</label>

                        <div v-for="(opcao, oi) in food.opcoes" :key="oi" class="border rounded p-3 mb-3 bg-light">
                          <div class="d-flex justify-content-between align-items-center mb-2">
                            <strong>{{ opcao.titulo }}</strong>
                            <button v-if="food.opcoes.length > 1" class="btn btn-sm btn-outline-danger"
                              @click="removeOpcao(food, oi)">×</button>
                          </div>

                          <label class="small text-muted">Alimentos</label>
                          <textarea class="form-control form-control-sm mb-2" rows="2" v-model="opcao.alimentos"
                            placeholder="Ex: 2 ovos mexidos, 2 fatias pão integral"></textarea>

                          <label class="small text-muted">Modo de Preparo (opcional)</label>
                          <textarea class="form-control form-control-sm" rows="2" v-model="opcao.preparo"
                            placeholder="Ex: Mexer ovos com 5g de manteiga"></textarea>
                        </div>

                        <button class="btn btn-sm btn-outline-success mb-3" @click="addOpcao(food)">+ Adicionar
                          Opção</button>

                        <!-- Macronutrientes -->
                        <label class="text-muted small uppercase">Macronutrientes</label>
                        <div class="row mb-3">
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.kcal"
                              placeholder="Kcal">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.proteina"
                              placeholder="Prot">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.carboidratos"
                              placeholder="Carb">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.gordura"
                              placeholder="Gord">
                          </div>
                        </div>

                        <!-- Dica -->
                        <label class="text-muted small uppercase">Dica do Nutricionista</label>
                        <textarea class="form-control mb-3 bg-light" rows="2" v-model="food.dica"
                          placeholder="Ex: Beba água ao acordar"></textarea>

                        <!-- Botão para converter para formato antigo -->
                        <button class="btn btn-xs btn-outline-secondary" @click="convertToOldFormat(food)">
                          Converter para formato simples
                        </button>
                      </div>

                      <!-- FORMATO ANTIGO (sem opções) -->
                      <div v-else>
                        <label class="text-muted small uppercase">Descrição</label>
                        <textarea class="form-control mb-3" rows="3" v-model="food.descricao"
                          placeholder="O que comer..."></textarea>

                        <!-- Macronutrientes -->
                        <label class="text-muted small uppercase">Macronutrientes (Opcional)</label>
                        <div class="row mb-3">
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.kcal"
                              placeholder="Kcal">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.proteina"
                              placeholder="Prot (g)">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.carboidratos"
                              placeholder="Carb (g)">
                          </div>
                          <div class="col-3">
                            <input type="text" class="form-control form-control-sm" v-model="food.macros.gordura"
                              placeholder="Gord (g)">
                          </div>
                        </div>

                        <!-- Dica do Nutri -->
                        <label class="text-muted small uppercase">Dica do Nutricionista</label>
                        <textarea class="form-control mb-3 bg-light" rows="2" v-model="food.dica_nutri"
                          placeholder="Ex: Beba água antes..."></textarea>

                        <!-- Substituições (formato antigo) -->
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <label class="text-muted small uppercase mb-0">Substituições</label>
                          <button class="btn btn-xs btn-outline-info" @click="addSub(food)">+ Adicionar</button>
                        </div>
                        <div v-for="(sub, si) in food.substituicoes" :key="si"
                          class="border rounded p-2 mb-2 bg-white position-relative">
                          <button class="btn btn-xs position-absolute" style="top:2px; right:2px"
                            @click="removeSub(food, si)">×</button>
                          <input type="text" class="form-control form-control-sm mb-1" v-model="sub.nome"
                            placeholder="O que substituir?">
                          <input type="text" class="form-control form-control-sm" v-model="sub.descricao"
                            placeholder="Quantidade/Detalhes">
                        </div>

                        <!-- Botão para converter para formato IA -->
                        <button class="btn btn-xs btn-outline-primary mt-2" @click="convertToAIFormat(food)">
                          Converter para formato com opções
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </div>
    </b-tabs>
    <hr>
    <button class="btn btn-success" v-show="food" @click="updateData()">Atualizar</button>
  </div>
</template>

<script>
export default {
  name: "CadAlimentacao",
  props: {
    food: Object,
    title: Boolean,
    active: Number,
  },
  data() {
    return {
      foods: {
        Segunda: [],
        Terça: [],
        Quarta: [],
        Quinta: [],
        Sexta: [],
        Sabado: [],
        Domingo: [],
      },
      semanas: [
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sabado",
        "Domingo",
      ],
    };
  },
  mounted() {
    this.checkOnlyView()
    this.$emit("save-food", this.foods);
  },
  methods: {
    addFood(semana) {
      let indiceInicial = 1;
      let ultimoId = null;
      if (this.foods[semana].length !== 0) {
        ultimoId =
          this.foods[semana][this.foods[semana].length - 1].id + 1;
      }

      const payload = {
        id: ultimoId || indiceInicial,
        nome: '',
        descricao: '',
        time: '',
        macros: { kcal: '', proteina: '', carboidratos: '', gordura: '' },
        dica_nutri: '',
        substituicoes: []
      };

      this.foods[semana].push(payload);
    },
    removeFood(id, semana) {
      const novoArray = this.foods[semana].filter((el) => el.id !== id);
      this.foods[semana] = novoArray;
    },
    addSub(meal) {
      if (!meal.substituicoes) {
        this.$set(meal, 'substituicoes', [])
      }
      meal.substituicoes.push({ nome: '', descricao: '' })
    },
    removeSub(meal, index) {
      meal.substituicoes.splice(index, 1)
    },
    addOpcao(meal) {
      if (!meal.opcoes) {
        this.$set(meal, 'opcoes', [])
      }
      const nextNumber = meal.opcoes.length + 1
      meal.opcoes.push({
        numero: nextNumber,
        titulo: `OPÇÃO ${nextNumber}`,
        alimentos: '',
        preparo: ''
      })
    },
    removeOpcao(meal, index) {
      meal.opcoes.splice(index, 1)
      // Renumera as opções restantes
      meal.opcoes.forEach((opcao, idx) => {
        opcao.numero = idx + 1
        opcao.titulo = `OPÇÃO ${idx + 1}`
      })
    },
    convertToOldFormat(meal) {
      // Converte de opcoes[] para descricao string
      if (meal.opcoes && meal.opcoes.length > 0) {
        const descricoes = meal.opcoes.map((opcao, idx) => {
          console.log(idx)
          let text = `${opcao.titulo}:\n${opcao.alimentos}`
          if (opcao.preparo) text += `\nPreparo: ${opcao.preparo}`
          return text
        })
        meal.descricao = descricoes.join('\n\n')
        delete meal.opcoes
        if (meal.dica) {
          meal.dica_nutri = meal.dica
          delete meal.dica
        }
      }
    },
    convertToAIFormat(meal) {
      // Converte de descricao para opcoes[]
      if (!meal.opcoes || meal.opcoes.length === 0) {
        this.$set(meal, 'opcoes', [
          {
            numero: 1,
            titulo: 'OPÇÃO 1',
            alimentos: meal.descricao || '',
            preparo: ''
          }
        ])
        if (meal.dica_nutri) {
          meal.dica = meal.dica_nutri
        }
      }
    },
    checkOnlyView() {
      if (this.food) {
        const parseDay = (input) => {
          let data = [];

          if (Array.isArray(input)) {
            data = input;
          } else if (typeof input === 'string') {
            try {
              data = JSON.parse(input || '[]');
            } catch {
              data = [];
            }
          }

          return data.map(item => ({
            ...item,
            macros: item.macros || { kcal: '', proteina: '', carboidratos: '', gordura: '' },
            dica_nutri: item.dica_nutri || '',
            substituicoes: item.substituicoes || []
          }))
        }

        this.foods.Segunda = parseDay(this.food.monday)
        this.foods['Terça'] = parseDay(this.food.tuesday)
        this.foods.Quarta = parseDay(this.food.wednesday)
        this.foods.Quinta = parseDay(this.food.thursday)
        this.foods.Sexta = parseDay(this.food.friday)
        this.foods.Sabado = parseDay(this.food.saturday)
        this.foods.Domingo = parseDay(this.food.sunday)
      }
    },
    updateData() {
      if (!this.food) return

      // Filtrar refeições vazias, mas PRESERVAR as com opcoes (geradas por IA)
      this.foods.Segunda = this.foods.Segunda.filter(x => x.nome || x.opcoes)
      this.foods['Terça'] = this.foods['Terça'].filter(x => x.nome || x.opcoes)
      this.foods.Quarta = this.foods.Quarta.filter(x => x.nome || x.opcoes)
      this.foods.Quinta = this.foods.Quinta.filter(x => x.nome || x.opcoes)
      this.foods.Sexta = this.foods.Sexta.filter(x => x.nome || x.opcoes)
      this.foods.Sabado = this.foods.Sabado.filter(x => x.nome || x.opcoes)
      this.foods.Domingo = this.foods.Domingo.filter(x => x.nome || x.opcoes)

      this.$emit("edit-food", this.foods);
    }
  },
};
</script>
